import { render, staticRenderFns } from "./DataDiscrepancies.vue?vue&type=template&id=f9848fe4"
import script from "./DataDiscrepancies.vue?vue&type=script&lang=js"
export * from "./DataDiscrepancies.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports